import HeatMapViz from '../vizs/HeatMapViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * A HeatMap is used to display the magnitude of a phenomenon as color in two dimensions. The variation in color may be by hue or intensity, giving obvious visual cues to the reader about how the phenomenon is clustered or varies over space.
 * 
 * ### Example Usage
 * ```javascript
 *   
 *   import {HeatMap} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new HeatMap($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with exactly 3 columns.
 * 
 * Each row represents a cell in the chart. The first two columns should represent the coordinates (x and y) and the third columnd should represent the value/color.
 * 
 * Note: the x and y coordinates can be numebers or strings, and will be sorted in the orther in which they appear in the table.
 * 
 * |     |  x    | y    |  color   |
 * |  ----  | ------| ---  |  ------  | 
 * |  1    |   a   |     A|      15.4| 
 * |  2    |   a   |     B|      29.3|   
 * |  3    |   a   |     C|      34.1|    
 * |  4    |   b   |     A|      12.3|  
 * |  5    |   b   |     B|      12.3|  
 * |  6    |   b   |     C|      12.3|  
 * |  7   |   c   |     A|      12.3|  
 * |  8    |   c   |     B|      12.3|  
 * |  9   |   c   |     C|      12.3|  
 * 
 * {.data-table}
 * 
 * */
export default class HeatMapComponent extends BaseComponent {
  static vizClass = HeatMapViz
  static componentLabel = "Heat map"
  static dataFormat = [
    {index:0,axis:'x0',label:'x category',types:[String],role:'partial-id',roleLabel:'X category'},
    {index:1,axis:'y0',label:'y category',types:[String],role:'partial-id',roleLabel:'Y category'},
    {index:2,axis:'',label:'color',types:[String],role:'value',roleLabel:'Value'},
  ]
  static defaultConfig = {
    title: this.componentLabel,
  }
}